<template>
    <div class="page product-page snapshot">
        <h1>Database snapshot</h1>
        <p>
            We're no longer creating semi-annual Unpaywall snapshots. But don't worry! You can get all of the data that is in
            Unpaywall (and much more) by downloading the latest snapshot from <a href="https://openalex.org">OpenAlex</a>.
        </p>
        <p>The OpenAlex snapshot is updated approximately once per month. Instructions on how and where to download the data
        are <a href="https://developers.openalex.org/download/snapshot-format">here</a>.</p>
    </div>

</template>
<script>
    export default {
        name: "Snapshot",
        metaInfo: {
            title: "Database Snapshot"
        }
    }
</script>

<style scoped>

</style>
